var path = '/app/components/dialogs/tutorial/tutorial.html';
var html = "<div class=intervencional-modal-wrap style=\"background-image:url('{{ step.bg }}')\" ng-repeat=\"step in $ctrl.steps\" ng-show=\"$index === $ctrl.step\"> <div class=modal-body> <div class=\"orange-balloon horizontal avatar-{{ $root.$currentUser.avatar + 1 }}\"> <p ng-bind-html=step.text></p> <a ng-click=$ctrl.toNext() class=btn-next-b></a> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/tutorial/tutorial.html
// module id = 272
// module chunks = 0